// Public configuration, verified against the existing fivemdocs.com entry.
// An empty value disables script loading and collection.
export const UMAMI_WEBSITE_ID: string = '79d91f2b-58ec-4af4-a21f-e6aa876f7771'
export const UMAMI_SCRIPT_URL = 'https://rpscripts.net/_sr/s.js'
